import React from "react"
import ImageCardWithProgress from "./ImageCardWithProgress"
import { getImageForPath } from "../../../misc/utils"


export const widgetImageCardProgressPrototype = [
    {
        "key": "border",
        "type": "STRING",
        "label": "Border",
        "size": 3
    }
]

const ImageCardProgressWidget = ({widget: inputWidget, triggerAction, value}) => {
    const widget = {...inputWidget, ...(value?.dataType === "widget" ? value : {})}
    
    const onClick = () => {
        widget.action && triggerAction(widget.action, value)
        triggerAction("NAVIGATE_THEMENFELD", value)
    }

    return (
        <ImageCardWithProgress
            imageUrl={getImageForPath(widget.image)}
            label={widget.text}
            progressValue={value?.progress ?? 0}
            onArrowClick={onClick}
            style={{border: widget.border}}
        />
    )
}

export default ImageCardProgressWidget
